import { createContext, useContext, useState } from 'react';

import { FCWithChildren } from 'common/types';

import { BulkTransferSharedState } from './types';

const BulkTransferContext = createContext<
  | {
      sharedState: BulkTransferSharedState;
      setSharedState: React.Dispatch<
        React.SetStateAction<BulkTransferSharedState>
      >;
    }
  | undefined
>(undefined);

const INITIAL_SHARED_STATE: BulkTransferSharedState = {
  bankAccountId: '',
  bucketName: '',
  companyProfileId: '',
  companyUserId: '',
  fileRef: '',
  nextBalance: 0,
  totalAmount: 0,
  transfers: [],
};

const BulkTransferContextProvider: FCWithChildren = ({ children }) => {
  const [sharedState, setSharedState] = useState(INITIAL_SHARED_STATE);

  return (
    <BulkTransferContext.Provider value={{ setSharedState, sharedState }}>
      {children}
    </BulkTransferContext.Provider>
  );
};

const useBulkTransferContext = () => {
  const context = useContext(BulkTransferContext);
  if (!context) {
    throw new Error(
      `useBulkTransferContext must be used within a BulkTransferContextProvider`,
    );
  }
  return context;
};

export { BulkTransferContextProvider, useBulkTransferContext };
